import React from 'react';
import { Card } from './ui/card';
import { Camera, MessageCircle, Calendar, Home } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      id: 'step-1',
      icon: <Camera className="w-10 h-10" />,
      title: 'Fotos oder Wohnungsgröße per WhatsApp senden',
      description: 'Senden Sie uns einfach Fotos Ihrer Wohnung oder die m²-Zahl via WhatsApp'
    },
    {
      id: 'step-2',
      icon: <MessageCircle className="w-10 h-10" />,
      title: 'Fixpreis-Angebot erhalten',
      description: 'Wir erstellen Ihnen schnell ein unverbindliches Fixpreis-Angebot'
    },
    {
      id: 'step-3',
      icon: <Calendar className="w-10 h-10" />,
      title: 'Termin vereinbaren',
      description: 'Wählen Sie Ihren Wunschtermin - flexibel nach Ihren Bedürfnissen'
    },
    {
      id: 'step-4',
      icon: <Home className="w-10 h-10" />,
      title: 'Wohnung sauber und professionell streichen lassen',
      description: 'Unsere Profis streichen Ihre Wohnung schnell und sauber'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            So einfach geht es
          </h2>
          <p className="text-xl text-slate-600">
            In 4 Schritten zu Ihrer frisch gestrichenen Wohnung
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {steps.map((step, index) => (
            <div key={step.id} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-1/2 w-full h-0.5 bg-blue-200 z-0"></div>
              )}
              
              <Card className="p-6 text-center hover:shadow-xl transition-all duration-300 relative z-10 bg-white border-2 hover:border-blue-300">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 text-blue-600 rounded-full mb-4 mx-auto">
                  {step.icon}
                </div>
                <div className="absolute -top-3 -right-3 w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                  {index + 1}
                </div>
                <h3 className="text-xl font-semibold text-slate-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-slate-600">
                  {step.description}
                </p>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;